import { Component, Input } from '@angular/core';

@Component({
  selector: 'idp-pill',
  templateUrl: './pill.component.html',
  styleUrls: ['./pill.component.scss']
})
export class PillComponent {
  @Input() title = '';
  @Input() pillColor = '';

  getClasses(): string {
    return `${this.pillColor}`;
  }
}
